import { render, staticRenderFns } from "./promocionesV2.vue?vue&type=template&id=74532f9e&scoped=true"
import script from "./promocionesV2.vue?vue&type=script&lang=js"
export * from "./promocionesV2.vue?vue&type=script&lang=js"
import style0 from "./promocionesV2.vue?vue&type=style&index=0&id=74532f9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74532f9e",
  null
  
)

export default component.exports